import React, { Component } from "react";
import PropTypes from "prop-types";

import DetailsView from "features/application/details/view";

class Details extends Component {
  constructor(props) {
    super(props);

    this.references = {
      day: React.createRef(),
      month: React.createRef(),
      year: React.createRef(),
    };

    this.capitalizeFirstLetter = this.capitalizeFirstLetter.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      validFields,
      invalidFields,
      removeValidField,
      setInvalidField,
    } = this.props;

    if (
      this.references.day.current &&
      this.references.month.current &&
      this.references.year.current
    ) {
      let day = this.references.day.current;
      let month = this.references.month.current;
      let year = this.references.year.current;
      let blurEvent = new Event("blur", { bubbles: true, cancelable: true });

      if (
        nextProps.validFields &&
        nextProps.validFields.includes("day") !== validFields.includes("day") &&
        !validFields.includes("day") &&
        invalidFields.includes("day")
      ) {
        month.dispatchEvent(blurEvent);
        year.dispatchEvent(blurEvent);
      }

      if (
        nextProps.validFields &&
        nextProps.validFields.includes("month") !==
          validFields.includes("month") &&
        !validFields.includes("month") &&
        invalidFields.includes("month")
      ) {
        day.dispatchEvent(blurEvent);
        year.dispatchEvent(blurEvent);
      }

      if (
        nextProps.validFields &&
        nextProps.validFields.includes("year") !==
          validFields.includes("year") &&
        !validFields.includes("year") &&
        invalidFields.includes("year")
      ) {
        day.dispatchEvent(blurEvent);
        month.dispatchEvent(blurEvent);
      }

      if (
        nextProps.validFields &&
        nextProps.validFields.includes("day") &&
        nextProps.validFields.includes("month") &&
        nextProps.validFields.includes("year")
      ) {
        if (
          new Date(
            parseInt(year.value),
            parseInt(month.value) - 1,
            parseInt(day.value)
          ) >= new Date()
        ) {
          removeValidField("day");
          removeValidField("month");
          removeValidField("year");
          setInvalidField("day");
          setInvalidField("month");
          setInvalidField("year");
        }
      }
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    const {
      errorCodes,
      userData,
      invalidFields,
      backToPreviousStep,
      sendApiRequest,
    } = this.props;

    return (
      <DetailsView
        errorCodes={errorCodes}
        userData={userData}
        invalidFields={invalidFields}
        references={this.references}
        backToPreviousStep={backToPreviousStep}
        sendApiRequest={sendApiRequest}
        capitalizeFirstLetter={this.capitalizeFirstLetter}
      />
    );
  }
}

Details.propTypes = {
  errorCodes: PropTypes.object,
  userData: PropTypes.object,
  invalidFields: PropTypes.array,
  removeValidField: PropTypes.func,
  setInvalidField: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
  validFields: PropTypes.array,
};

export default Details;
